export const Article = () => {
	return (
		<>
			<p>I am often asked: what is Hexa and how it differs than language-xyz?</p>

			<p>Some examples:</p>
			<blockquote>
				<p>how hexa will be better than haxe? What to purpose of this Lang?</p>
				<blockquote>
					<p><a href="https://twitter.com/JMichaelShlomo">JMichaelShlomo</a></p>
				</blockquote>
			</blockquote>

			<blockquote>
				<p>It IS a creazy idea.</p>
				<blockquote>
					<p><a href="https://groups.google.com/d/msg/haxelang/zGLnwJRaThU/tEckOyt6iy8J">https://groups.google.com/d/msg/haxelang/zGLnwJRaThU/tEckOyt6iy8J</a></p>
				</blockquote>
			</blockquote>

			<blockquote>
				<p>curious - what problem(s) are you trying to solve?</p>
				<blockquote>
					<p><a href="https://twitter.com/jeff__ward">jeff__ward</a></p>
				</blockquote>
			</blockquote>

			<p>Some links from deep multi-year history of the project:</p>
			<ul>
				<li>2014 LuaXe Lua target for Haxe <a href="https://github.com/bradparks/LuaXe">https://github.com/bradparks/LuaXe</a> (fork of LuaXe) was my research in dynamic languages optimization</li>
				<li>2014 Attempt on LLVM Haxe backend <a href="https://github.com/bradparks/Native">https://github.com/bradparks/Native</a> (fork of Native)</li>
				<li>2015 Announcing Alternative Haxe <a href="https://groups.google.com/forum/#!msg/haxelang/zGLnwJRaThU/kCwQ46HmSW8J">https://groups.google.com/forum/#!msg/haxelang/zGLnwJRaThU/kCwQ46HmSW8J</a></li>
				<li>2016 OpenHaxe opportunity (or Haxe-in-Haxe)</li>
				<li>2017 Hexa <a href="https://github.com/hexalang/hexa">https://github.com/hexalang/hexa</a> my final decision to roll out my own programming language</li>
			</ul>

			<p>Results? Well…</p>

			<blockquote>
				<p>What exactly have you done? i cant see anything.</p>
				<blockquote>
					<p><a href="https://groups.google.com/d/msg/haxelang/zGLnwJRaThU/hOO4Ohmj7acJ">https://groups.google.com/d/msg/haxelang/zGLnwJRaThU/hOO4Ohmj7acJ</a></p>
				</blockquote>
			</blockquote>

			<p>So I want to announce a short blog posts series about design decisions, experiments and so on.
				Follow blog for updates.</p>
		</>
	)
}
